// features/item-filter/useItemSearchCopy.js
//
// The label and placeholder of a box that searches items — one home, so every
// such box, in the filter bar and in a popup, says the same thing.
//
// The placeholder names the identifiers the merchant can actually type. All
// three fields are searched on every store (core.utils.ITEM_SEARCH_FIELDS),
// but on an image-capable store the item code is the variant GID's numeric
// suffix — inviting them to search by it invites them to search by a number
// they have never seen.

import { useTranslation } from 'react-i18next';
import { useIsShopify } from '../../contexts/AuthContext';

export function useItemSearchCopy() {
  const { t } = useTranslation();
  const isShopify = useIsShopify();
  return {
    label: t('searchFilters.itemSearchLabel'),
    placeholder: t(isShopify ? 'searchFilters.itemSearchPlaceholderShopify'
                             : 'searchFilters.itemSearchPlaceholder'),
  };
}
